module.exports = __webpack_public_path__ + "img/icon_tab_03_w.8d99707f.svg";